function chatHandler(event) {
  event?.preventDefault?.();
  window.zE?.('webWidget', 'open');
}

export const useChatHandler = () => chatHandler;
